import { z } from "zod";
export const AnalyticsSchema = z.object({
    contentId: z.string(),
    contentLocale: z.string(),
    contentCategory: z.string().optional(),
    version: z.number().optional(),
    rev: z.string().optional(),
    publishDate: z.string(),
});
//# sourceMappingURL=index.js.map